<script>
  import { events } from "../stores.js"
  import { navigate } from "svelte-routing"
  import { init } from "../services/users"

  import Header from "../components/Header.svelte"

  function refresh() {
    init()
    const interval = setInterval(init, 30000)
    return {
      destroy() {
        clearInterval(interval)
      },
    }
  }
</script>

<Header text="welcome" />

<section class="section create" use:refresh>
  <div class="container has-text-centered">
    <button
      class="button is-primary is-large"
      on:click={() => navigate("/events")}
    >
      CREATE NEW EVENT
    </button>
  </div>
</section>

<section class="section">
  {#if $events.length > 0}
    <h6>Select an existing live event:</h6>
    {#each $events as { eventName, templateName, channelName }}
      <div class="event" on:click={() => navigate(`/events/${eventName}`)}>
        <div class="is-size-6 has-text-black">
          <label>Name:</label><span class="has-text-weight-semibold"
            >{eventName}</span
          >
        </div>
        <div class="is-size-7 has-text-grey-dark">
          <label>Channel:</label><span class="has-text-weight-semibold"
            >{channelName}</span
          >
        </div>
      </div>
    {/each}
  {:else}
    <div
      class="is-size-3 is-size-4-mobile has-text-centered fullwidth noevents"
    >
      currently no running events
    </div>
  {/if}
</section>

<style>
  .event {
    cursor: pointer;
    padding: 5px;
    margin-bottom: 5px;
    background-color: cornflowerblue;
    border: 1px solid #111;
  }

  .event label {
    width: 60px;
    display: inline-block;
  }

  .create {
    margin-top: 100px;
    margin-bottom: 60px;
  }
</style>
